import { isEmptyString } from '@vy/utils';
import type { FieldPath, FieldValues, RegisterOptions, UseFormRegister } from 'react-hook-form';

export function vyFormRegister<FieldValue extends FieldValues, FieldName extends FieldPath<FieldValue>>(
  register: UseFormRegister<FieldValue>,
  fieldPath: FieldName,
  options?: RegisterOptions<FieldValue, FieldName>,
  customSetValueAs?: (val: string) => number | string | undefined | null,
) {
  return register<FieldName>(fieldPath, {
    ...options,
    setValueAs: customSetValueAs ?? ((val: string) => (isEmptyString(val) ? undefined : val)),
  });
}
